import { HttpService } from '@/infra'
import type { TUltimoAtendimento } from '@/types/atendimento'

export class GetUltimosAtendimentosService extends HttpService {
  async execute(): Promise<TUltimoAtendimento[]> {
    const response = await this.http.get<TUltimoAtendimento[]>('api/v2/Atendimento/ultimosAtendimentos')
    return response.data
  }
}
